import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonType } from '@shared/ui/buttons';
import { IconType } from '@shared/utils/icons';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'shared-ui-modal-base-modal',
  templateUrl: './base-modal.component.html',
  styleUrls: ['./base-modal.component.css'],
  standalone: false,
})
export class BaseModalComponent {
  @Input() title!: string;

  @Input() hasXButton = true;

  @Input() hasIcon = false;

  @Input() confirmButtonTitle = 'Confirm';

  @Input() confirmSecondButtonTitle = 'Confirm';

  @Input() confirmButtonType = ButtonType.Primary;

  @Input() confirmButtonIcon: IconType = IconType.None;

  @Input() cancelButtonTitle = 'Cancel';

  @Input() cancelButtonType = ButtonType.DefaultOutline;

  @Input() canConfirm = true;

  @Input() canCancel = true;

  @Input() confirmButtonDisabled = false;

  @Input() closeOnConfirm = true;

  @Input() hasBody = true;

  @Input() useSecondButton = false;

  @Input() hasCopyButton = false;

  @Input() hasBrowseButton = false;

  @Input() hasRetryButton = false;

  @Input() retryButtonTitle = 'Retry';

  @Input() textToCopy? = '';

  @Input() disableAllButtons = false;

  @Output() confirmOutput = new EventEmitter<void>();

  @Output() confirmOutputSecondButton = new EventEmitter<void>();

  @Output() confirmBrowseOutput = new EventEmitter<void>();

  @Output() retryOutput = new EventEmitter<void>();

  ButtonType = ButtonType;
  IconType = IconType;

  constructor(public activeModal: DynamicDialogRef) {}

  confirmClose(): void {
    this.confirmOutput.emit();

    if (this.closeOnConfirm) {
      this.activeModal.close(true);
    }
  }

  confirmCloseSecondButton(): void {
    this.confirmOutputSecondButton.emit();

    if (this.closeOnConfirm) {
      this.activeModal.close();
    }
  }

  browseOutput(): void {
    this.confirmBrowseOutput.emit();
  }

  retryAction(): void {
    this.retryOutput.emit();
  }
}
